import { Ui } from '@dora/vivian/';
import * as Hooks from 'preact/hooks';
import * as Actions from '../store/actions/app';
import { useDispatch, useSelector } from '../store/redux';
import * as Selectors from '../store/selectors';

export const useExploreTracking = (p: {
    inConfiguration: boolean;
    partsLoading: boolean;
    hasParts: boolean;
    addRemoveCta?:
        | {
              status: 'add';
              onClick: () => void;
          }
        | {
              status: 'remove';
              onClick: () => void;
          };
    showAddParts: boolean | undefined;
    initialLoad: boolean;
    heroProperties: Ui.PropertyOption.PropertyChoice[];
}) => {
    const [configurationButtonVisibleTracked, setConfigurationButtonVisibleTracked] =
        Hooks.useState(false);
    const dispatch = useDispatch();

    const basketValue = useSelector(Selectors.Basket.basket);

    Hooks.useEffect(() => {
        if (!p.initialLoad && !p.partsLoading && !configurationButtonVisibleTracked) {
            setConfigurationButtonVisibleTracked(true);

            const buttonVisible =
                p.addRemoveCta !== undefined || p.hasParts || p.heroProperties.length > 0;
            dispatch(Actions.configureButtonVisibleAction(buttonVisible));
        }
    }, [p.hasParts, p.partsLoading, p.initialLoad, p.addRemoveCta]);

    const [addPartsButtonVisibleTracked, setAddPartsButtonVisibleTracked] = Hooks.useState(false);

    Hooks.useEffect(() => {
        if (p.showAddParts !== undefined && addPartsButtonVisibleTracked === false) {
            setAddPartsButtonVisibleTracked(true);
            const buttonVisible = p.inConfiguration || p.showAddParts;
            dispatch(Actions.addPartsButtonVisibleAction(buttonVisible));
        }
    }, [p.showAddParts]);

    /**
     * 'addRemoveCta.status' is set to 'remove' on interacting with 'Add Parts'
     * -> Set START mark on clicking 'Add Parts'.
     * -> Set END mark when 'initialLoad' is marked as complete.
     */
    Hooks.useEffect(() => {
        if (p.addRemoveCta?.status === 'remove') {
            if (p.initialLoad) {
                performance.mark('add-parts-start');
            }

            if (!p.initialLoad) {
                performance.mark('add-parts-end');
            }
        }
    }, [p.initialLoad]);

    /**
     * IF 'basketValue' exists AND 'initialLoad' is marked as complete AND 'add-parts-end' performance mark exists
     * THEN take measurement, dispatch it, and clear performance marks.
     */
    Hooks.useEffect(() => {
        if (
            basketValue &&
            !p.initialLoad &&
            performance.getEntriesByName('add-parts-end', 'mark').length !== 0
        ) {
            const measure = Math.round(
                performance.measure('add-parts-duration', 'add-parts-start', 'add-parts-end')
                    .duration,
            ).toFixed(2);

            dispatch(Actions.addPartsLoadingDurationAction(measure));

            performance.clearMarks();
            performance.clearMeasures();
        }
    }, [basketValue, p.initialLoad]);
};
